import { useEffect, useRef, useState, useMemo } from "react";
import { ColDef, ColumnApi, GridApi, GridOptions } from "@ag-grid-enterprise/all-modules";

const autoSizeColumns = ({ columnApi }: { api: GridApi; columnApi: ColumnApi }) => {
    const ids = columnApi.getAllColumns();
    // don't autosize last column
    if (ids) {
        ids?.pop();
        columnApi.autoSizeColumns(ids);
    }
};

export function useTemplateGridOptions(defaultColDef: Array<ColDef>): [GridOptions, GridApi | undefined] {
    const [gridApi, setGridApi] = useState<GridApi>();

    const gridApiRef = useRef<GridApi>();

    useEffect(() => {
        if (gridApi) {
            gridApi.setColumnDefs([...defaultColDef]);
        }
    }, [gridApi]);

    return [
        useMemo<GridOptions>(
            () => ({
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    editable: false
                },
                getRowNodeId: (data: { id: string }) => data.id,
                getRowClass: params => params.data.id,
                allowContextMenuWithControlKey: true,
                enableBrowserTooltips: true,
                animateRows: true,
                rowSelection: "single",
                suppressAggFuncInHeader: true,
                onFirstDataRendered: e => autoSizeColumns(e),
                immutableData: true,
                popupParent: document.getElementById("root")!,
                // getContextMenuItems: getContextMenuItems,
                // processCellForClipboard: processCellForClipboard,
                onGridReady: e => {
                    setGridApi(e.api);
                    gridApiRef.current = e.api;
                }
            }),
            []
        ),
        gridApi
    ];
}
